import { Stage } from './stage';
import { getTableName } from './utilities/tables';

export const ActivityTableName = getTableName('activity', 'NucleusPlatformResources', Stage);
export const AuditlogTableName = getTableName('auditlog', 'NucleusPlatformResources', Stage);
export const ChurchpersonTableName = getTableName('churchperson', 'NucleusPlatformResources', Stage);
export const ChurchTableName = getTableName('church', 'NucleusPlatformResources', Stage);
export const EmailTableName = getTableName('email', 'NucleusPlatformResources', Stage);
export const FileTableName = getTableName('file', 'NucleusPlatformResources', Stage);
export const InvitationTableName = getTableName('invitation', 'NucleusPlatformResources', Stage);
export const LogincognitoTableName = getTableName('logincognito', 'NucleusPlatformResources', Stage);
export const NotificationTableName = getTableName('notification', 'NucleusPlatformResources', Stage);
export const OrganizationTableName = getTableName('organization', 'NucleusPlatformResources', Stage);
export const PersonTableName = getTableName('person', 'NucleusPlatformResources', Stage);
export const RoleTableName = getTableName('role', 'NucleusPlatformResources', Stage);
